/**
 * Reimbursements list columns — config-driven, user-customizable via the
 * "Columns" box. Mirrors the application module's column system
 * (`APPLICATION_LIST_COLUMN_OPTIONS` and friends).
 */

export const REIMBURSEMENTS_LIST_COLUMN_OPTIONS = [
  { id: 'applicant_id', label: 'Applicant' },
  { id: 'resident_name', label: 'Resident' },
  { id: 'property_name', label: 'Property' },
  { id: 'company_name', label: 'Management Company' },
  { id: 'agent_name', label: 'Agent Responsible' },
  { id: 'certificate_amount', label: 'Access Fee Paid' },
  { id: 'default_paid', label: 'Paid' },
  { id: 'reimbursement_type', label: 'Reimbursement Type' },
  { id: 'reimbursement_rental_status', label: 'Reimbursement Status' },
  { id: 'reimbursement_rental_progress', label: 'Reimbursement Progress' },
  { id: 'claim_status', label: 'Claim Status' },
  { id: 'review_decision', label: 'Review Decision' },
  { id: 'document_status', label: 'Document Status' },
  { id: 'contract_start_date', label: 'Lease Start Date' },
  { id: 'vintage', label: 'Vintage Year' },
  { id: 'rental_status_date', label: 'Reimbursement Request Date' },
  { id: 'adjust_max_movein_date', label: '6mo Max Date' },
  { id: 'default_status_date', label: 'Reimbursement Status Date' },
  { id: 'access_confirmation', label: 'Access Confirmation' },
  { id: 'statement', label: 'Statement' },
] as const

/**
 * Always rendered in the list table; excluded from Customize columns.
 * `applicant_id` (Applicant) is the locked anchor — mirrors the application
 * module. It only renders for the Liberty org (see `canRenderColumn`).
 */
export const REIMBURSEMENTS_LIST_LOCKED_COLUMN_IDS = ['applicant_id'] as const

/**
 * Columns offered in the Customize columns box (everything except the locked
 * anchor). Access Confirmation and Statement are included here so they can be
 * toggled/reordered; they still only appear for the Liberty org.
 */
export const REIMBURSEMENTS_LIST_CUSTOMIZABLE_COLUMN_OPTIONS =
  REIMBURSEMENTS_LIST_COLUMN_OPTIONS.filter(
    (column) => column.id !== 'applicant_id',
  )

/** Every column id (all columns take part in visibility/ordering). */
export const REIMBURSEMENTS_LIST_DATA_COLUMN_IDS =
  REIMBURSEMENTS_LIST_COLUMN_OPTIONS.map((column) => column.id)

export const REIMBURSEMENTS_COLUMN_VISIBILITY_STORAGE_KEY =
  'reimbursements-list-column-visibility-v2'
